import { getContext, take, fork } from 'redux-saga/effects'
import { ERROR_CODES, NOTIFICATION_TYPES } from 'shared/constants'

import {
  LOGIN_USER_FAILURE,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_DEVICE_SUCCESS,
  VERIFY_DEVICE_FAILURE,
  VERIFY_RESET_SUCCESS,
  VERIFY_RESET_FAILURE,
  VERIFY_INVITATION_SUCCESS,
  VERIFY_INVITATION_FAILURE,
  REFRESH_TOKEN_FAILURE
} from 'store/constants/session'

import {
  CREATE_TEAM_SUCCESS,
  CREATE_TEAM_FAILURE,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_FAILURE,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILURE
} from 'store/constants/team'

import {
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
  PROJECT_ADD_TEAM_SUCCESS,
  PROJECT_ADD_TEAM_FAILURE,
  PROJECT_REMOVE_TEAM_SUCCESS,
  PROJECT_REMOVE_TEAM_FAILURE
} from 'store/constants/project'

import {
  API_ASSIGN_PARAMETERS_SUCCESS,
  API_ASSIGN_PARAMETERS_FAILURE,
  CREATE_API_SUCCESS,
  CREATE_API_FAILURE,
  UPDATE_API_SUCCESS,
  UPDATE_API_FAILURE,
  DELETE_API_SUCCESS,
  DELETE_API_FAILURE,
  REMOVE_KEY_FROM_API_SUCCESS,
  REMOVE_KEY_FROM_API_FAILURE
} from 'store/constants/api'

import { CREATE_KEY_SUCCESS, CREATE_KEY_FAILURE } from 'store/constants/key'

import {
  MORFIX_CREATE_ENC_PARMS_FAILURE,
  MORFIX_CREATE_CONTEXT_SUCCESS,
  MORFIX_CREATE_CONTEXT_FAILURE,
  MORFIX_CREATE_BATCH_ENCODER_FAILURE,
  MORFIX_CREATE_CKKS_ENCODER_FAILURE,
  MORFIX_CREATE_EVALUATOR_FAILURE,
  MORFIX_CREATE_KEY_GENERATOR_FAILURE,
  MORFIX_GENERATE_PUBLIC_KEY_SUCCESS,
  MORFIX_GENERATE_PUBLIC_KEY_FAILURE,
  MORFIX_GENERATE_SECRET_KEY_SUCCESS,
  MORFIX_GENERATE_SECRET_KEY_FAILURE,
  MORFIX_GENERATE_RELIN_KEY_SUCCESS,
  MORFIX_GENERATE_RELIN_KEY_FAILURE,
  MORFIX_GENERATE_GALOIS_KEY_SUCCESS,
  MORFIX_GENERATE_GALOIS_KEY_FAILURE,
  MORFIX_DOWNLOAD_PUBLIC_KEY_FAILURE,
  MORFIX_DOWNLOAD_SECRET_KEY_FAILURE,
  MORFIX_DOWNLOAD_RELIN_KEY_FAILURE,
  MORFIX_DOWNLOAD_GALOIS_KEY_FAILURE,
  MORFIX_UPLOAD_PUBLIC_KEY_SUCCESS,
  MORFIX_UPLOAD_PUBLIC_KEY_FAILURE,
  MORFIX_UPLOAD_SECRET_KEY_SUCCESS,
  MORFIX_UPLOAD_SECRET_KEY_FAILURE,
  MORFIX_UPLOAD_RELIN_KEY_SUCCESS,
  MORFIX_UPLOAD_RELIN_KEY_FAILURE,
  MORFIX_UPLOAD_GALOIS_KEY_SUCCESS,
  MORFIX_UPLOAD_GALOIS_KEY_FAILURE,
  MORFIX_CREATE_PLAIN_TEXT_SUCCESS,
  MORFIX_CREATE_PLAIN_TEXT_FAILURE,
  MORFIX_CREATE_CIPHER_TEXT_SUCCESS,
  MORFIX_CREATE_CIPHER_TEXT_FAILURE,
  MORFIX_DELETE_PLAIN_TEXT_SUCCESS,
  MORFIX_DELETE_PLAIN_TEXT_FAILURE,
  MORFIX_DELETE_CIPHER_TEXT_SUCCESS,
  MORFIX_DELETE_CIPHER_TEXT_FAILURE,
  MORFIX_UPLOAD_PLAIN_TEXT_SUCCESS,
  MORFIX_UPLOAD_PLAIN_TEXT_FAILURE,
  MORFIX_UPLOAD_CIPHER_TEXT_SUCCESS,
  MORFIX_UPLOAD_CIPHER_TEXT_FAILURE,
  MORFIX_BATCH_ENCODE_INT32_FAILURE,
  MORFIX_BATCH_ENCODE_UINT32_FAILURE,
  MORFIX_CKKS_ENCODE_FLOAT64_FAILURE,
  MORFIX_BATCH_DECODE_INT32_FAILURE,
  MORFIX_BATCH_DECODE_UINT32_FAILURE,
  MORFIX_CKKS_DECODE_FLOAT64_FAILURE,
  MORFIX_ENCRYPT_FAILURE,
  MORFIX_DECRYPT_FAILURE,
  MORFIX_EVALUATE_NEGATE_CIPHER_FAILURE,
  MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_FAILURE,
  MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_FAILURE,
  MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_FAILURE,
  MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_FAILURE,
  MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_FAILURE,
  MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_FAILURE,
  MORFIX_EVALUATE_SQUARE_CIPHER_FAILURE,
  MORFIX_EVALUATE_RELINEARIZE_CIPHER_FAILURE,
  MORFIX_EVALUATE_EXPONENTIATE_CIPHER_FAILURE,
  MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_FAILURE,
  MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_FAILURE,
  MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_FAILURE,
  MORFIX_EVALUATE_ROTATE_ROWS_FAILURE,
  MORFIX_EVALUATE_ROTATE_COLUMNS_FAILURE,
  MORFIX_EVALUATE_ROTATE_VECTOR_FAILURE,
  MORFIX_EVALUATE_COMPLEX_CONJUGATE_FAILURE,
  MORFIX_EVALUATE_SUM_ELEMENTS_FAILURE,
  MORFIX_EVALUATE_DOT_PRODUCT_FAILURE,
  MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_FAILURE
} from 'store/constants/morfix'

import {
  ENGINE_UPLOAD_SECRET_KEY_SUCCESS,
  ENGINE_UPLOAD_SECRET_KEY_FAILURE,
  ENGINE_PREPARE_SUCCESS,
  ENGINE_PREPARE_FAILURE,
  ENGINE_COMPUTE_FAILURE,
  ENGINE_RESPONSE_FAILURE,
  ENGINE_RESPONSE_SUCCESS
} from 'store/constants/engine'

/**
 * Allowed Notification types
 */
const actionsToNotify = [
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAILURE,
  PROJECT_ADD_TEAM_SUCCESS,
  PROJECT_ADD_TEAM_FAILURE,
  PROJECT_REMOVE_TEAM_SUCCESS,
  PROJECT_REMOVE_TEAM_FAILURE,

  API_ASSIGN_PARAMETERS_SUCCESS,
  API_ASSIGN_PARAMETERS_FAILURE,
  CREATE_API_SUCCESS,
  CREATE_API_FAILURE,
  UPDATE_API_SUCCESS,
  UPDATE_API_FAILURE,
  DELETE_API_SUCCESS,
  DELETE_API_FAILURE,
  REMOVE_KEY_FROM_API_SUCCESS,
  REMOVE_KEY_FROM_API_FAILURE,

  CREATE_KEY_SUCCESS,
  CREATE_KEY_FAILURE,

  CREATE_TEAM_SUCCESS,
  CREATE_TEAM_FAILURE,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_FAILURE,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILURE,

  LOGIN_USER_FAILURE,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_DEVICE_SUCCESS,
  VERIFY_DEVICE_FAILURE,
  VERIFY_RESET_SUCCESS,
  VERIFY_RESET_FAILURE,
  VERIFY_INVITATION_SUCCESS,
  VERIFY_INVITATION_FAILURE,
  REFRESH_TOKEN_FAILURE,

  MORFIX_CREATE_ENC_PARMS_FAILURE,
  MORFIX_CREATE_CONTEXT_SUCCESS,
  MORFIX_CREATE_CONTEXT_FAILURE,
  MORFIX_CREATE_BATCH_ENCODER_FAILURE,
  MORFIX_CREATE_CKKS_ENCODER_FAILURE,
  MORFIX_CREATE_EVALUATOR_FAILURE,
  MORFIX_CREATE_KEY_GENERATOR_FAILURE,
  MORFIX_GENERATE_PUBLIC_KEY_SUCCESS,
  MORFIX_GENERATE_PUBLIC_KEY_FAILURE,
  MORFIX_GENERATE_SECRET_KEY_SUCCESS,
  MORFIX_GENERATE_SECRET_KEY_FAILURE,
  MORFIX_GENERATE_RELIN_KEY_SUCCESS,
  MORFIX_GENERATE_RELIN_KEY_FAILURE,
  MORFIX_GENERATE_GALOIS_KEY_SUCCESS,
  MORFIX_GENERATE_GALOIS_KEY_FAILURE,
  MORFIX_DOWNLOAD_PUBLIC_KEY_FAILURE,
  MORFIX_DOWNLOAD_SECRET_KEY_FAILURE,
  MORFIX_DOWNLOAD_RELIN_KEY_FAILURE,
  MORFIX_DOWNLOAD_GALOIS_KEY_FAILURE,
  MORFIX_UPLOAD_PUBLIC_KEY_SUCCESS,
  MORFIX_UPLOAD_PUBLIC_KEY_FAILURE,
  MORFIX_UPLOAD_SECRET_KEY_SUCCESS,
  MORFIX_UPLOAD_SECRET_KEY_FAILURE,
  MORFIX_UPLOAD_RELIN_KEY_SUCCESS,
  MORFIX_UPLOAD_RELIN_KEY_FAILURE,
  MORFIX_UPLOAD_GALOIS_KEY_SUCCESS,
  MORFIX_UPLOAD_GALOIS_KEY_FAILURE,
  MORFIX_CREATE_PLAIN_TEXT_SUCCESS,
  MORFIX_CREATE_PLAIN_TEXT_FAILURE,
  MORFIX_CREATE_CIPHER_TEXT_SUCCESS,
  MORFIX_CREATE_CIPHER_TEXT_FAILURE,
  MORFIX_DELETE_PLAIN_TEXT_SUCCESS,
  MORFIX_DELETE_PLAIN_TEXT_FAILURE,
  MORFIX_DELETE_CIPHER_TEXT_SUCCESS,
  MORFIX_DELETE_CIPHER_TEXT_FAILURE,
  MORFIX_UPLOAD_PLAIN_TEXT_SUCCESS,
  MORFIX_UPLOAD_PLAIN_TEXT_FAILURE,
  MORFIX_UPLOAD_CIPHER_TEXT_SUCCESS,
  MORFIX_UPLOAD_CIPHER_TEXT_FAILURE,
  MORFIX_BATCH_ENCODE_INT32_FAILURE,
  MORFIX_BATCH_ENCODE_UINT32_FAILURE,
  MORFIX_CKKS_ENCODE_FLOAT64_FAILURE,
  MORFIX_BATCH_DECODE_INT32_FAILURE,
  MORFIX_BATCH_DECODE_UINT32_FAILURE,
  MORFIX_CKKS_DECODE_FLOAT64_FAILURE,
  MORFIX_ENCRYPT_FAILURE,
  MORFIX_DECRYPT_FAILURE,
  MORFIX_EVALUATE_NEGATE_CIPHER_FAILURE,
  MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_FAILURE,
  MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_FAILURE,
  MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_FAILURE,
  MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_FAILURE,
  MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_FAILURE,
  MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_FAILURE,
  MORFIX_EVALUATE_SQUARE_CIPHER_FAILURE,
  MORFIX_EVALUATE_RELINEARIZE_CIPHER_FAILURE,
  MORFIX_EVALUATE_EXPONENTIATE_CIPHER_FAILURE,
  MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_FAILURE,
  MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_FAILURE,
  MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_FAILURE,
  MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_FAILURE,
  MORFIX_EVALUATE_ROTATE_ROWS_FAILURE,
  MORFIX_EVALUATE_ROTATE_COLUMNS_FAILURE,
  MORFIX_EVALUATE_ROTATE_VECTOR_FAILURE,
  MORFIX_EVALUATE_COMPLEX_CONJUGATE_FAILURE,
  MORFIX_EVALUATE_SUM_ELEMENTS_FAILURE,
  MORFIX_EVALUATE_DOT_PRODUCT_FAILURE,
  MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_FAILURE,

  ENGINE_UPLOAD_SECRET_KEY_SUCCESS,
  ENGINE_UPLOAD_SECRET_KEY_FAILURE,
  ENGINE_PREPARE_SUCCESS,
  ENGINE_PREPARE_FAILURE,
  ENGINE_COMPUTE_FAILURE,
  ENGINE_RESPONSE_FAILURE,
  ENGINE_RESPONSE_SUCCESS
]

/**
 * Ignore Notification Types
 */
const actionsToIgnore = [ERROR_CODES.UNAUTHORIZED]

export default function* createNotificationWatcher() {
  const workers = yield getContext('workers')

  while (true) {
    const action = yield take(
      action => actionsToNotify.includes(action.type) && !actionsToIgnore.includes(action.payload.statusCode)
    )

    // Skip notifications if the payload contains the proper key
    if (action.payload.notify === false) {
      continue
    }

    const data = {
      ...action,
      payload: {
        ...action.payload,
        type: action.type.includes('FAILURE')
          ? NOTIFICATION_TYPES.ERROR
          : action.type.includes('SUCCESS')
          ? NOTIFICATION_TYPES.SUCCESS
          : NOTIFICATION_TYPES.INFO
      }
    }
    yield fork(workers.ui.createNotificationWorker, data)
  }
}
